import { liveFeed } from "@/mocks/homeData";

export default function LiveFeed() {
  return (
    <section id="live" className="w-full bg-foreground-950 px-4 py-12 md:px-8 md:py-16">
      <div className="grid grid-cols-1 gap-10 lg:grid-cols-[1fr_380px] lg:gap-14">
        <div>
          <div className="flex items-center gap-3">
            <span className="relative flex h-2.5 w-2.5">
              <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-primary-400 opacity-75" />
              <span className="relative inline-flex h-2.5 w-2.5 rounded-full bg-primary-500" />
            </span>
            <span className="font-label text-[11px] tracking-[0.24em] text-accent-400">LIVE FEED</span>
          </div>
          <h3 className="mt-3 font-heading text-2xl font-black tracking-tight text-background-50 md:text-3xl">
            实时爆料
          </h3>
          <p className="mt-3 max-w-lg font-body text-sm leading-7 text-foreground-300">
            不设滤镜的滚动记录。这里只有一句话、一个时间点，真假由你自己判断。
          </p>

          <ul className="mt-8 divide-y divide-background-50/10 border-t border-background-50/10">
            {liveFeed.map((item, idx) => (
              <li key={`${item.time}-${idx}`} className="flex items-start gap-4 py-4 md:gap-6">
                <time className="w-20 shrink-0 whitespace-nowrap pt-0.5 font-label text-xs text-accent-400 md:w-24">
                  {item.time}
                </time>
                <p className="font-body text-sm leading-7 text-background-100">{item.text}</p>
              </li>
            ))}
          </ul>

          <button
            type="button"
            className="mt-6 flex items-center gap-2 whitespace-nowrap rounded-md border border-background-50/25 px-5 py-2.5 font-label text-sm text-background-100 transition-colors duration-200 hover:border-accent-400 hover:text-accent-300"
          >
            <i className="ri-refresh-line text-base" />
            加载更早的爆料
          </button>
        </div>

        <aside className="flex flex-col gap-4">
          <div className="rounded-lg border border-background-50/15 bg-background-50/5 p-5">
            <h4 className="font-heading text-base font-bold text-background-50">今日数据</h4>
            <dl className="mt-4 grid grid-cols-2 gap-4">
              <div>
                <dt className="font-label text-xs text-foreground-400">新增线索</dt>
                <dd className="mt-1 font-heading text-2xl font-black text-accent-400">128</dd>
              </div>
              <div>
                <dt className="font-label text-xs text-foreground-400">在榜话题</dt>
                <dd className="mt-1 font-heading text-2xl font-black text-background-50">17</dd>
              </div>
              <div>
                <dt className="font-label text-xs text-foreground-400">已核实</dt>
                <dd className="mt-1 font-heading text-2xl font-black text-background-50">9</dd>
              </div>
              <div>
                <dt className="font-label text-xs text-foreground-400">存疑</dt>
                <dd className="mt-1 font-heading text-2xl font-black text-primary-400">23</dd>
              </div>
            </dl>
          </div>
          <div className="rounded-lg border border-background-50/15 bg-background-50/5 p-5">
            <h4 className="flex items-center gap-2 font-heading text-base font-bold text-background-50">
              <i className="ri-information-line text-accent-400" />
              阅读提示
            </h4>
            <p className="mt-3 font-body text-[13px] leading-6 text-foreground-300">
              本站内容来自网友投稿与公开信息整理，仅代表线索本身，不代表本站立场。请勿据此对任何个人作出判断。
            </p>
          </div>
        </aside>
      </div>
    </section>
  );
}